var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{ref:"textarea",attrs:{"outlined":"","label":_vm.label,"clearable":"","hideDetails":_vm.hideDetails,"dense":"","rules":_vm.rules,"height":_vm.height,"value":_vm.value},on:{"change":e => _vm.$emit('change', e),"input":e => _vm.$emit('input', e)}})
}
var staticRenderFns = []

export { render, staticRenderFns }